import React from 'react';

import { CampaignManagerLanding } from '../CampaignManagerLanding/CampaignManagerLanding';

export const CampaignManagerLandingPage: React.FC = () => (
  <CampaignManagerLanding />
);
